import { useMemo } from "react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { GetChartLinkResponse } from "../../../../../app/services/selfHireService/getChartLink";
import { getCssVariable } from "@/app/utils/getCssVariable";

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        label: (context: any) => {
          const dataIndex = context.dataIndex;
          const dataset = context.chart.data.datasets[0];
          const accessCount = dataset.labels[dataIndex];
          const date = dataset.dates[dataIndex];

          return [`Data: ${date}`, `Acessos: ${accessCount}`];
        },
        title: () => "",
      },
      displayColors: false,
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      titleColor: "white",
      bodyColor: "white",
      borderColor: "rgba(255, 255, 255, 0.2)",
      borderWidth: 1,
      cornerRadius: 8,
      padding: 12,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        font: {
          size: 16,
          weight: 600,
        },
        color: "#6B7280",
      },
      border: {
        display: false,
      },
    },
    y: {
      grid: {
        color: "#E5E7EB",
        borderDash: [5, 5],
      },
      border: {
        display: false,
      },
      ticks: {
        font: {
          size: 16,
          weight: 600,
        },
        color: "#6B7280",
        callback: function (value: any) {
          return Math.round(value);
        },
        stepSize: 1,
      },
      beginAtZero: true,
      suggestedMax: function (context: any) {
        const maxValue = Math.max(...context.chart.data.datasets[0].data);
        return Math.ceil(maxValue / 10) * 5;
      },
    },
  },
  elements: {
    point: {
      radius: 4,
      hoverRadius: 6,
      backgroundColor: function (context: any) {
        const dataset = context.chart.data.datasets[0];
        return dataset.borderColor;
      },
      borderColor: function (context: any) {
        const dataset = context.chart.data.datasets[0];
        return dataset.borderColor;
      },
      borderWidth: 2,
    },
    line: {
      tension: 0.4,
    },
  },
};

export function useLinkChart(chartData: GetChartLinkResponse | undefined) {
  const primaryColor = useMemo(() => {
    const primary = getCssVariable("--primary");
    if (primary) return `hsl(${primary})`;

    return "hsl(150, 100%, 40%)";
  }, []);

  const data = {
    labels:
      chartData?.data.map(({ date }) =>
        format(new Date(date), "dd MMM", { locale: ptBR }),
      ) || [],
    datasets: [
      {
        data: chartData?.data.map((entry) => entry.count) || [],
        borderColor: primaryColor,
        backgroundColor: primaryColor
          .replace("hsl", "hsla")
          .replace(")", ", 0.2)"),
        borderWidth: 3,
        tension: 0.4,
        fill: true,
        labels: chartData?.data.map((entry) => entry.count) || [],
        dates:
          chartData?.data.map((entry) =>
            format(new Date(entry.date), "dd/MM/yyyy", { locale: ptBR }),
          ) || [],
      },
    ],
  };

  return { data, options };
}
